import { ICourseModel } from 'models/course.model'
import api from '..'

const getCourse = (courseId: number) => {
  return api.get(`courses/${courseId}`).then(
    ({
      data: {
        data: { attributes },
      },
    }): ICourseModel => {
      return {
        ...attributes,
        enrol: attributes.enrol && attributes.enrol.data.attributes,
      }
    }
  )
}

export default getCourse
